import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import Loader from "../../components/shared/Loader";
// import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";

import JoditEditor from "components/shared/JoditEditor";
import { handleImageLink } from "../../helpers/Function";
const BlogShow = ({ match }) => {
	const {
		params: { blogID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(0);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	// let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل المقال",
				breadcrumb: "المدونة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/blogs/${blogID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.title?.ar || response.data.data.title);
				setDescription(
					response.data.data.description?.ar || response.data.data.description
				);
				setPicture(handleImageLink(response.data.data.image));
				setSelectedCategory(
					response.data.data.category?.id || response.data.data.category_id?.id
				);
				setPageTitle(response.data.data.page_title);
				setPageDescrition(response.data.data.page_description);
				setPageKeyWords(response.data.data.page_keywords);
				setPageUrl(response.data.data.page_url_title);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
		axios
			.get(`${process.env.REACT_APP_API_URL}/blog_categories`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCategories(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = e => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = async e => {
		e.preventDefault();
		setLoading(true);
		const titleArray = {
			ar: title,
			en: "ttt",
		};
		const descriptionArray = {
			ar: description,
			en: "ttt",
		};
		let image = picture;
		const picture1 = document.querySelector("#picture");
		if (picture1.files[0]) {
			const data = new FormData();
			data.append("file", picture1.files[0]);
			image = (
				await axios.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
			)?.data?.data?.name;
			// 	.then(response => {
			// 		axios
			// 			.put(
			// 				`${process.env.REACT_APP_API_URL}/blogs/${blogID}`,
			// 				{
			// 					title: titleArray,
			// 					description: descriptionArray,
			// 					admin_id: auth.data.id,
			// 					image: response.data.data.name,
			// 					category_id: selectedCategory,
			// 					page_title: pageTitle,
			// 					page_description: pageDescrition,
			// 					page_keywords: pageKeyWords,
			// 					page_url_title: pageUrl,
			// 				},
			// 				{
			// 					headers: {
			// 						Authorization: `Bearer ${cookie.get("token")}`,
			// 						Accept: "application/json",
			// 					},
			// 				}
			// 			)
			// 			.then(function (response) {
			// 				toast.success("تم تحديث المقالة بنجاح!");
			// 				setLoading(false);
			// 			})
			// 			.catch(function (error) {
			// 				toast.error("خطأ، برجاء المحاولة مره اخرى!");
			// 				setLoading(false);
			// 			});
			// 	})
			// 	.catch(error => {
			// 		toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
			// 		setLoading(false);
			// 	});
			// return;
		}
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/blogs/${blogID}`,
				{
					title: titleArray,
					description: descriptionArray,
					admin_id: auth.data.id,
					image,
					category_id: selectedCategory,
					page_title: pageTitle,
					page_description: pageDescrition,
					page_keywords: pageKeyWords,
					page_url_title: pageUrl,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث المقالة بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				console.log("error", error);
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};
	// const useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="category">التصنيف</label>
									<select
										id="category"
										value={selectedCategory}
										onChange={e => setSelectedCategory(e.target.value)}
									>
										<option value={0} disabled>
											اختر التصنيف
										</option>
										{categories?.map(category => (
											<option value={category.id} key={category.id}>
												{category.name}
											</option>
										))}
									</select>
								</div>
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										onChange={e => setTitle(e.target.value)}
										value={title}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="description">النص</label>
									{/* <Editor
										initialValue={description}
										onChange={(e, editor) => {
											const data = editor.getContent();
											setDescription(data);
										}}
										apiKey="qxbhpez69tx8w5eo9pwc1ark6iqt3cwvrygww12thb0gta0f"
										init={{
											plugins:
												"print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
											menubar: "file edit view insert format tools table help",
											toolbar:
												"customInsertButton  | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen  preview print | insertfile image media link table | ltr rtl | language | undo redo",
											toolbar_sticky: false,
											autosave_ask_before_unload: true,
											autosave_interval: "10s",
											autosave_prefix: "{path}{query}-{id}-",
											autosave_restore_when_empty: true,
											autosave_retention: "2m",
											mobile: {
												menubar: true,
											},
											directionality: "rtl",
											// language: "ar",
											height: 600,
											image_caption: true,
											quickbars_selection_toolbar:
												"bold italic | quicklink h2 h3 blockquote quickimage quicktable ",
											noneditable_noneditable_class: "mceNonEditable",
											toolbar_mode: "wrap",
											contextmenu: "link image imagetools table",
											// skin: useDarkMode ? "oxide-dark" : "oxide",
											// content_css: useDarkMode ? "dark" : "default",
											content_style: "",
											setup: function (editor) {
												editor.ui.registry.addButton("customInsertButton", {
													text: "custom Button",
													onAction: function (_) {
														editor.insertContent(
															`&nbsp;<a href="" class="btn" style="    background: linear-gradient(
																148deg,#1d5cd1,#0ba1d8 84%);
															color: #fff;
															padding: 10px 20px;
															border-radius: 50px;
															display: inline-block;
															cursor: pointer;
															text-decoration: none;">my button!</a>&nbsp;`
														);
													},
												});
											},
										}}
									/> */}
									<JoditEditor
										value={description}
										onChange={val => setDescription(val)}
										placeholder="اكتب هنا..."
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
										value={pageTitle}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
										value={pageUrl}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
										value={pageDescrition}
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
										value={pageKeyWords}
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default BlogShow;
